/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
const collapseItem = (
    theme,
    { active, transparentSidenav, whiteSidenav, darkMode }
) => {
  const { palette, functions, transitions } = theme;
  const { pxToRem, linearGradient } = functions;
  const { gradients, white, dark } = palette;

  const isLight = (transparentSidenav && !darkMode) || whiteSidenav;

  return {
    mx: 1.2,
    my: 0.45,
    px: 1.3,
    py: 1,
    minHeight: pxToRem(48),
    display: "flex",
    alignItems: "center",
    borderRadius: pxToRem(15),
    cursor: "pointer",
    userSelect: "none",
    position: "relative",
    overflow: "hidden",

    color: active
        ? white.main
        : isLight
            ? dark.main
            : "rgba(255,255,255,0.88)",

    background: active
        ? linearGradient(gradients.info.main, gradients.info.state)
        : "rgba(255,255,255,0.02)",

    border: active
        ? "1px solid rgba(255,255,255,0.18)"
        : "1px solid transparent",

    boxShadow: active
        ? "0 12px 28px rgba(26,115,232,0.35)"
        : "none",

    transition: transitions.create(
        ["background", "box-shadow", "transform", "border-color"],
        { duration: transitions.duration.shorter }
    ),

    "&:hover": {
      transform: "translateX(4px)",
      background: active
          ? linearGradient(gradients.info.main, gradients.info.state)
          : darkMode
              ? "rgba(255,255,255,0.09)"
              : "rgba(0,0,0,0.045)",
      borderColor: "rgba(255,255,255,0.14)",
      boxShadow: "0 10px 22px rgba(0,0,0,0.18)",
    },

    "&:active": {
      transform: "scale(0.985)",
    },

    "&::before": active
        ? {
          content: '""',
          position: "absolute",
          left: 0,
          top: "22%",
          width: pxToRem(4),
          height: "56%",
          borderRadius: pxToRem(8),
          background: white.main,
        }
        : {},
  };
};
const collapseIconBox = (
    theme,
    { transparentSidenav, whiteSidenav, darkMode }
) => {
  const { palette, functions, transitions } = theme;
  const { pxToRem } = functions;
  const { white, dark } = palette;

  const isLight = (transparentSidenav && !darkMode) || whiteSidenav;

  return {
    minWidth: pxToRem(38),
    width: pxToRem(38),
    height: pxToRem(38),
    borderRadius: pxToRem(13),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mr: 1.2,

    background: darkMode
        ? "rgba(255,255,255,0.08)"
        : "rgba(255,255,255,0.14)",

    color: isLight ? dark.main : white.main,

    transition: transitions.create(["background", "transform"], {
      duration: transitions.duration.shorter,
    }),

    ".MuiBox-root:hover &": {
      transform: "scale(1.08)",
      background: "rgba(255,255,255,0.18)",
    },
  };
};
const collapseIcon = ({ palette: { white, gradients } }, { active }) => ({
  color: active ? white.main : gradients.dark.state,
});

const collapseText = (
    theme,
    { miniSidenav, transparentSidenav, whiteSidenav, active }
) => {
  const { palette, functions, transitions } = theme;
  const { pxToRem } = functions;
  const { white, dark } = palette;

  const color = active
      ? white.main
      : transparentSidenav || whiteSidenav
          ? dark.main
          : "rgba(255,255,255,0.9)";

  return {
    opacity: miniSidenav ? 0 : 1,
    transition: transitions.create("opacity", {
      duration: transitions.duration.shorter,
    }),

    "& .MuiListItemText-primary": {
      fontSize: pxToRem(16),
      fontWeight: active ? 700 : 600,
      letterSpacing: "0.2px",
      color,
      whiteSpace: "nowrap",
    },
  };
};
const collapseArrow = (
    theme,
    { noCollapse, miniSidenav, open, active, transparentSidenav, whiteSidenav }
) => {
  const { palette, functions, transitions } = theme;
  const { pxToRem } = functions;
  const { white, dark } = palette;

  return {
    display: noCollapse || miniSidenav ? "none" : "block",
    ml: "auto",
    fontSize: `${pxToRem(18)} !important`,
    color: active || (!transparentSidenav && !whiteSidenav)
        ? white.main
        : dark.main,
    opacity: 0.8,
    transform: open ? "rotate(0deg)" : "rotate(180deg)",
    transition: transitions.create(["transform", "opacity"], {
      duration: transitions.duration.shorter,
    }),
  };
};
export {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
  collapseArrow,
};
